<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório quantitativo de viagem">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/relatorio-quantitativo/List'

export default {
    components: { List },
}
</script>
